/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface StringSetAttributeDTO
 */
export interface StringSetAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof StringSetAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof StringSetAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringSetAttributeDTO
     */
    values: Array<string>;
}



/**
 * Check if a given object implements the StringSetAttributeDTO interface.
 */
export function instanceOfStringSetAttributeDTO(value: object): value is StringSetAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function StringSetAttributeDTOFromJSON(json: any): StringSetAttributeDTO {
    return StringSetAttributeDTOFromJSONTyped(json, false);
}

export function StringSetAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringSetAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'values': json['values'],
    };
}

export function StringSetAttributeDTOToJSON(value?: StringSetAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'values': value['values'],
    };
}

